// src/views/admin/clients/index.jsx
import { useToast, Button } from '@chakra-ui/react';
import AdminPageShell from '../../../components/layout/AdminPageShell';
import VehiclesTable from '../../../components/Vehicles/VehiclesTable.js';
import { columnsDataVehicles } from './variables/columnsDataVehicles.js';
import React, { useEffect, useState } from 'react';
import { getData, postData, putData } from '../../../utils/httpClient.js'; // Importa la función fetchCustomers
import { useSearch } from '../../../contexts/SearchContext.js';
import VehiclesEditModal from '../../../components/Vehicles/VehiclesEditModal.js';
import { useResetPageOnFilterChange } from '../../../hooks/useResetPageOnFilterChange.js';
import { useTableSorting } from '../../../hooks/useTableSorting.js';
import authService from '../../../services/authService.js';

export default function Settings() {
  const isReadOnly = authService.isMechanic();
  const { searchQuery, resetListFilters } = useSearch(); 
  const [data, setData] = useState([]); 
  const [page, setPage] = useState(0); 
  const [totalPages, setTotalPages] = useState(0); 
  const [rowsPerPage, setRowsPerPage] = useState(10); 
  const [modalState, setModalState] = useState({ isOpen: false, vehicle: null, isNew: false });
  const toast = useToast();
  const { sorting, setSorting, sortBy, sortDir, appendSortParams } = useTableSorting();

  useResetPageOnFilterChange(setPage, page, [searchQuery, rowsPerPage, sortBy, sortDir]);

  const loadData = async (dato) => {
    try {
      const params = new URLSearchParams({
        page: String(page + 1),
        limit: String(rowsPerPage),
        data: dato || '',
      });
      appendSortParams(params);
      const response = await getData(`/vehicles?${params.toString()}`);
      setData(response?.payload?.vehicles || []); // Actualiza los datos
      setTotalPages(Math.ceil(response?.payload?.total / rowsPerPage));
    } catch (error) {
      toast({
        title: 'Error al obtener vehículos.',
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
    }
  };

  useEffect(() => {
    loadData(searchQuery);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, searchQuery, rowsPerPage, sortBy, sortDir]);

  useEffect(() => {
    resetListFilters();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


  const openNewVehicleModal = () => {
    setModalState({ isOpen: true, vehicle: null, isNew: true });
  };

  const openEditVehicleModal = (vehicle) => {
    setModalState({ isOpen: true, vehicle, isNew: false });
  };

  const closeEditModal = () => {
    setModalState({ isOpen: false, vehicle: null, isNew: false });
  };

  const handleCreateVehicle = async (newVehicle) => {
    try {
      await postData('/vehicles', newVehicle);
      loadData(searchQuery);
    } catch (error) {
      // Lanzar el error para que el modal pueda manejarlo
      throw error;
    }
  };

  const handleUpdateVehicle = async (vehicle) => {
    try {
      await putData(`/vehicles/${vehicle.id}`, vehicle);
      await loadData(searchQuery); 
    } catch (error) {
      // Lanzar el error para que el modal pueda manejarlo
      throw error;
    }
  };

  return (
    <AdminPageShell
      title="Vehículos"
      actions={!isReadOnly ? (
        <Button variant="adminPrimary" size="sm" onClick={openNewVehicleModal}>
          Nuevo vehículo
        </Button>
      ) : null}
    >
      <VehiclesTable
          columnsData={columnsDataVehicles.map((column) =>
            column.accessor === 'actions' && isReadOnly
              ? {
                  ...column,
                  actions: column.actions.filter((action) => action.type === 'view'),
                }
              : column,
          )}
          data={data} 
          page={page}
          setPage={setPage}
          totalPages={totalPages}
          pageSize={rowsPerPage}
          setPageSize={setRowsPerPage}
          handleUpdateVehicle={handleUpdateVehicle}
          onEditVehicle={openEditVehicleModal}
          sorting={sorting}
          onSortingChange={setSorting}
        />

      {!isReadOnly && (
        <VehiclesEditModal
          isOpen={modalState.isOpen}
          onClose={closeEditModal}
          vehicle={modalState.vehicle}
          isNew={modalState.isNew}
          onCreate={handleCreateVehicle} 
          onUpdate={handleUpdateVehicle}
        />
      )}
    </AdminPageShell>
  );
}
